// Canonical-host redirect logic, extracted for testability.
export const CANONICAL_ORIGIN = "https://trendsdiscovery.com";

export interface LocationLike {
  hostname: string;
  pathname: string;
  search: string;
  hash: string;
}

export function isLocalHost(host: string): boolean {
  return (
    host === "localhost" ||
    host === "127.0.0.1" ||
    host.endsWith(".lovable.app") ||
    host.endsWith(".lovableproject.com")
  );
}

export function isCanonicalHost(host: string): boolean {
  return host === "trendsdiscovery.com" || host === "www.trendsdiscovery.com";
}

/**
 * Returns the URL to redirect to, or null if no redirect should occur.
 * Preserves pathname, search (query string), and hash fragment.
 */
export function getCanonicalRedirectUrl(loc: LocationLike): string | null {
  if (isLocalHost(loc.hostname) || isCanonicalHost(loc.hostname)) {
    return null;
  }
  return CANONICAL_ORIGIN + loc.pathname + loc.search + loc.hash;
}
